import { putCollectionPointPaymentThunk } from "../../../../reducers/collectionPointReducer";
import { BillingPaymentPeriod } from "../../../../types/billings";
import { PutCollectionPointPaymentArgs } from "../../../../types/collectionPoint";
import { IModal } from "../../../../types/modal";
import { BillingChangeModal } from "../BillingChangeModal";

interface BillingPaymentChangeModalProps extends IModal {
  period: BillingPaymentPeriod;
  isPaid: boolean;
}

export const BillingPaymentChangeModal = ({
  period,
  isPaid,
  isModalVisible,
  toggleModalVisibility,
}: BillingPaymentChangeModalProps) => {
  return (
    <BillingChangeModal<PutCollectionPointPaymentArgs>
      translationKey="collectionPoint.billingPaymentChangeModal"
      thunk={putCollectionPointPaymentThunk}
      payload={{ period, isPaid }}
      isModalVisible={isModalVisible}
      toggleModalVisibility={toggleModalVisibility}
      isPaid={isPaid}
    />
  );
};
